import { useAdminApi } from '@hooks/useAdminApi';
import { useCallback, useEffect, useState } from 'react';
import { LiveWebsocket } from '@protos/v2/serverinfo';
import { useNavigate } from 'react-router-dom';
import { LiveWebsocketGrid } from '@shared/components/LiveWebsocketGrid';
import { CellClickedEvent } from 'ag-grid-enterprise';
import { useAsync } from 'react-use';
import { handleFieldNavigation } from '../trading/utils';

export const LiveWebsockets = () => {
  const { apiClient } = useAdminApi();
  const navigate = useNavigate();
  const [liveWebsockets, setLiveWebsockets] = useState<LiveWebsocket[]>([]);

  const fetchLiveWebsockets = useCallback(async () => {
    const fetchedLiveWebsockets = await apiClient?.getLiveWebsockets();
    setLiveWebsockets(fetchedLiveWebsockets || []);
  }, [apiClient]);

  useAsync(async () => {
    fetchLiveWebsockets();
  }, [apiClient, fetchLiveWebsockets]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchLiveWebsockets();
    }, 5000);
    return () => clearInterval(interval);
  }, [fetchLiveWebsockets]);

  const handleUserClicked = useCallback(
    (params: CellClickedEvent) => {
      handleFieldNavigation(navigate, 'user_id', params.data?.user_id);
    },
    [navigate]
  );

  return <LiveWebsocketGrid data={liveWebsockets} onUserClicked={handleUserClicked} height="95vh" />;
};
